import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import ArrowDropUp from '@mui/icons-material/ArrowDropUp';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import {
  Collapse,
  Grid,
  List,
  ListItem,
  ListItemText,
  styled,
  Tooltip,
  Typography,
} from '@mui/material';
import React, { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GlobalFilterTypeHandle } from '../../../../context/types';
import { darkTeal, mediumGray, teal2 } from '../../../theme';
import { Filter } from '../filterbar/types';
import { FilterSection } from '../types';
import { MyFilterItemList } from './MyFilterItemList';
import { MyFilterSectionFallback } from './MyFilterSectionFallback';
import { SaveDialog } from './SaveDialog';

export const StyledList = styled(List)<{ $backgroundColor: string }>`
  padding: 0px !important;
  color: white;
  background-color: ${(props) => props.$backgroundColor};
`;

const StyledSaveAsIcon = styled(SaveAsIcon)`
  cursor: pointer;

  &:hover {
    color: ${teal2};
  }
`;

interface MyFilterSectionProps {
  filtersHandle: GlobalFilterTypeHandle<Filter>;
  filterSections: FilterSection[];
}

export const MyFilterSection = (props: MyFilterSectionProps) => {
  const { t } = useTranslation();
  const [expand, setExpand] = useState(false);
  const [openSave, setOpenSave] = useState(false);
  const { filtersHandle, filterSections } = props;
  const [filtersState] = filtersHandle;

  return (
    <StyledList $backgroundColor={darkTeal} dense>
      <ListItem
        sx={{
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'space-between',
          padding: '2px 4px 2px 16px',
        }}
        onClick={() => setExpand((prev) => !prev)}
      >
        <Grid item>
          <ListItemText>
            <Grid container item alignItems="center">
              <Typography sx={{ paddingRight: '1em' }}>
                {t('common:filterTray.myFilterGroups')}
              </Typography>
              {filtersState.items?.length ? (
                <Tooltip
                  title={t('common:filterTray.clickToSaveTooltip')}
                  placement="top"
                >
                  <StyledSaveAsIcon
                    color="secondary"
                    onClick={() => setOpenSave(true)}
                  />
                </Tooltip>
              ) : (
                <Tooltip
                  title={t('common:filterTray.pleaseSelectFiltersTooltip')}
                  placement="top"
                >
                  <SaveAsIcon sx={{ color: mediumGray }} />
                </Tooltip>
              )}
            </Grid>
          </ListItemText>
        </Grid>
        <Grid item>
          {expand ? (
            <ArrowDropUp color="secondary" />
          ) : (
            <ArrowDropDown color="secondary" />
          )}
        </Grid>
      </ListItem>
      <Collapse in={expand} timeout="auto" unmountOnExit>
        <Grid container>
          <Suspense fallback={<MyFilterSectionFallback expand={expand} />}>
            <MyFilterItemList
              filtersHandle={filtersHandle}
              setExpand={setExpand}
              filterSections={filterSections}
            />
          </Suspense>
        </Grid>
      </Collapse>
      <SaveDialog<Filter>
        filtersHandle={filtersHandle}
        dialogHandle={[openSave, setOpenSave]}
        setExpand={setExpand}
        filterSections={filterSections}
      />
    </StyledList>
  );
};
